import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Header from '../components/Header';
import Marketing from '../components/Marketing';
import Hero from '../components/Hero';
import Social from '../components/Social';

import DefaultSceeen from '../components/DefaultScreen';


import moment from 'moment';
import useInterval from "../hooks/useInterval";

import { mysqlDatetime, noCacheReq } from '../utilities';

const settings_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/settings/promotions';
const demo_events_url = 'https://api.asianart.org/wp-json/aam/1.0.0/events/demo';
const alert_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/alert';
const events_url = 'https://api.asianart.org/wp-json/aam/1.0.0/events/';

export default function() {

    const [settings,setSettings] = useState( false );
    const [events,setEvents] = useState( [] );
    const [alert,setAlert] = useState( {} );

    const getFeaturedEvents = () => {
        const start = new Date();
        const end = new Date( new Date().setDate( start.getDate() + 30 ) );
        end.setHours( 23, 59, 59, 999 );
        return noCacheReq( events_url, {
            start: mysqlDatetime( start ),
            end: mysqlDatetime( end ),
            all_info: 1,
            meta_query: {
                parameters: [
                    {
                        "key": "aam__event_featured_event",
                        "value": "1",
                        "compare": "="
                    }
                ]
            }
        } );
    };

    useEffect( () => {

        Promise.all( [ noCacheReq( settings_url ), noCacheReq( demo_events_url ), getFeaturedEvents() ] ).then( data => {
            const settings = data[ 0 ];
            const events_data = data[ 2 ];
            let events_arr = [];

            events_data.forEach( event => {
                const start = new Date( event.start_date );
                const end = new Date( event.end_date );
                const start_date = moment( start ).format( 'dddd, MMM D / h:mm A' );
                const end_date = moment( end ).format( 'h:mm A' );

                events_arr.push( {
                    supertitle: event?.type?.name,
                    title: event?.title ? event.title : event?.post_title,
                    subtitle: `${start_date} – ${end_date}`,
                    image: event[ 'image-sign-hero' ][ 0 ],
                } );
            } );

            setSettings( settings );
            setEvents( events_arr );
        } );
    }, [] );

    useInterval( () => {
        noCacheReq( alert_url ).then( data => {
            setAlert( data );
        } );
    }, 10000 );

    return settings ? (
        <Container>
            <Header title={settings.section_title}
                    alertActive={alert.alert_active}
                    alertMessage={alert.alert_bar_text}
                    alertSpeed={ alert.alert_speed }/>
            {
                events.length ? (
                    <Hero slides={events}
                          duration={settings.hero_slide_duration}
                          vignette={settings.vignette_opacity}/>
                ) : (
                    <DefaultSceeen/>
                )
            }
            <Marketing
                title={settings.marketing_panel_title}
                desc={settings.marketing_panel_desc}
                note={settings.marketing_panel_note}
                image={settings.marketing_panel_image}/>
            <Social
                title={settings.social_title}
                images={[
                    settings[ 'social_image-0' ],
                    settings[ 'social_image-1' ],
                    settings[ 'social_image-2' ]
                ]}/>
        </Container>
    ) : <Loading><h1>Loading...</h1></Loading>;
}

const Container = styled.div`
   display: flex;
   flex-direction: column;
`;

const Loading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;